import { render, staticRenderFns } from "./AccountInfo.vue?vue&type=template&id=5daa0fd8&"
import script from "./AccountInfo.vue?vue&type=script&lang=js&"
export * from "./AccountInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NewsLetterCheckbox: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/NewsLetterCheckbox.vue').default})
